import { ia, iaRa } from 'lib/helpers/utility';

import { calculateTotalCharge } from 'components/practice/charts/SuperBillPage/lib';
import { formatProcedureModifiers } from 'components/practice/charts/SuperBillPage/lib/reshapeProcedures';

import { amountToCents } from './amountToCents';

export const updateProcedureAdjustments = ({
  setClaim = () => {},
  procedureIndex,
  payerType,
  index,
  key,
  value,
  setErrors = () => {}
}) => {
  setClaim((prevClaim) => {
    const updatedProcedures = [...prevClaim.procedures];
    const procedure = updatedProcedures[procedureIndex];

    const adjustmentsArray = procedure[payerType] ? [...procedure[payerType]] : [];
    if (adjustmentsArray?.length === 0) {
      adjustmentsArray.push({});
    }
    const lastIdx = adjustmentsArray?.length - 1;
    const lastAdjustment = { ...adjustmentsArray[lastIdx] };
    if (ia(lastAdjustment?.pt_adj)) {
      const merged = [...iaRa(lastAdjustment?.ins_adj), ...lastAdjustment.pt_adj];
      lastAdjustment.ins_adj = merged;
      delete lastAdjustment.pt_adj;
    }

    const tempLastAdjustment = { ...lastAdjustment };

    if (typeof index === 'number') {
      const insAdj = ia(tempLastAdjustment?.ins_adj) ? [...tempLastAdjustment.ins_adj] : [];
      if (!insAdj[index]) {
        insAdj[index] = {};
      }
      if (key === 'code') {
        const group = (value.slice(0, 2) || '').trim();
        const code = (value.slice(2) || '').trim();
        insAdj[index] = { ...insAdj[index], group, code };
      } else {
        insAdj[index] = { ...insAdj[index], [key]: value };
      }
      tempLastAdjustment.ins_adj = insAdj;
    } else {
      tempLastAdjustment[key] = value;
    }

    if (key === 'amount' || key === 'paid') {
      const totalInsAdj = (tempLastAdjustment?.ins_adj || []).reduce(
        (acc, adj) => acc + amountToCents(adj?.amount),
        0
      );

      const totalPaid = Number(tempLastAdjustment?.paid || 0);
      const totalAdjustment = totalInsAdj + totalPaid;
      if (totalAdjustment > procedure?.charge) {
        setErrors((prev) => ({ ...prev, paidError: true }));
      } else {
        setErrors((prev) => ({ ...prev, paidError: false }));
      }
    }

    if (key === 'paid_date') {
      const fromDate = new Date(procedure?.from_date);
      const paidDate = new Date(value);
      if (paidDate < fromDate) {
        setErrors((prev) => ({ ...prev, dateError: true }));
      } else {
        setErrors((prev) => ({ ...prev, dateError: false }));
      }
    }

    adjustmentsArray[lastIdx] = tempLastAdjustment;
    updatedProcedures[procedureIndex] = {
      ...procedure,
      [payerType]: adjustmentsArray
    };

    return {
      ...prevClaim,
      procedures: formatProcedureModifiers({ procedures: updatedProcedures }),
      total_charge: calculateTotalCharge(updatedProcedures, true)
    };
  });
};
